import { Alert, Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SellIcon from '@mui/icons-material/Sell';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { useNavigate } from 'react-router-dom';

function CustomerPortalComingSoon({ feature = '', mode = 'general', onSwitchAccount = null }) {
  const navigate = useNavigate();
  const isAuthEntry = mode === 'auth-entry';

  const handleSwitchAccount = () => {
    if (typeof onSwitchAccount === 'function') {
      onSwitchAccount();
      return;
    }

    navigate('/', { replace: true });
  };

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', py: { xs: 1, md: 2 } }}>
      <Card
        sx={{
          borderRadius: 4,
          mb: 3,
          background: 'linear-gradient(135deg, #0f766e 0%, #0f172a 100%)',
          color: 'white',
          boxShadow: '0 20px 50px rgba(15, 23, 42, 0.3)',
        }}
      >
        <CardContent sx={{ p: { xs: 3, md: 5 } }}>
          <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
            Customer Portal Is Coming Soon
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.92, maxWidth: 760 }}>
            We are preparing the customer shopping experience. This section is currently under rollout.
          </Typography>
        </CardContent>
      </Card>

      {feature && (
        <Alert severity="info" sx={{ mb: 2 }}>
          <strong>{feature}</strong> is not live yet. Thanks for your patience.
        </Alert>
      )}

      <Card sx={{ borderRadius: 3 }}>
        <CardContent sx={{ p: { xs: 3, md: 4 } }}>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
            What You Will Get Soon
          </Typography>
          <Stack spacing={1.5} sx={{ mb: 3 }}>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <StorefrontIcon color="primary" />
              <Typography>Browse available stores near you.</Typography>
            </Stack>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <SellIcon color="primary" />
              <Typography>View products and prices set by each store.</Typography>
            </Stack>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <ShoppingBagIcon color="primary" />
              <Typography>Place online orders directly from the app.</Typography>
            </Stack>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <ChatBubbleOutlineIcon color="primary" />
              <Typography>Send messages to stores for order updates and queries.</Typography>
            </Stack>
          </Stack>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
            {isAuthEntry ? (
              <>
                <Button variant="contained" onClick={handleSwitchAccount}>
                  Back To Role Selection
                </Button>
                <Button variant="outlined" onClick={handleSwitchAccount}>
                  Login As Business Owner
                </Button>
              </>
            ) : (
              <>
                <Button variant="contained" onClick={() => navigate('/')}>
                  Customer Home
                </Button>
                <Button variant="outlined" onClick={() => navigate('/profile')}>
                  Go To Profile
                </Button>
              </>
            )}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}

export default CustomerPortalComingSoon;
